import React, { useEffect, useRef } from 'react';
import './hero.scss';
import logo from '../../assets/logo.svg';
import videoLoopD from '../../assets/heroD.mp4';
import videoLoopM from '../../assets/heroM.mp4';

function Hero() {
  const videoLoopRef = useRef();

  useEffect(() => {
    videoLoopRef.current.play();
  }, []);

  return (
    <section className="hero">
      {/* <div className="hero__overlay" /> */}

      <video autoPlay muted playsInline loop className="hero__videoloop" ref={videoLoopRef}>
        <source media="(min-width:481px)" src={videoLoopD} type="video/mp4" />
        <source media="(max-width:480px)" src={videoLoopM} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>

      <a
        href="https://us-keepexploring.canada.travel/"
        target="_blank"
        rel="noreferrer"
        aria-label="Visit Destination Canada homepage"
      >
        <img className="hero__logo" src={logo} alt="" />
      </a>
    </section>
  );
}

export default Hero;
